module.exports = __webpack_public_path__ + "img/crosswork.772049af.png";